/* =========================================================
   Real Reviews — reveal + score count-up + star pop animation
   ========================================================= */

(function () {
  'use strict';

  function initReviews(root) {
    if (!root || root.dataset.revInit === 'true') return;
    root.dataset.revInit = 'true';

    const reducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ---------- Reveal on scroll ----------
    const revealEls = root.querySelectorAll('.reveal');

    if ('IntersectionObserver' in window && revealEls.length) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in');
              io.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -50px 0px',
        }
      );
      revealEls.forEach((el) => io.observe(el));
    } else {
      revealEls.forEach((el) => el.classList.add('in'));
    }

    if (reducedMotion) return;

    // ---------- Score count-up ----------
    const scoreEl = root.querySelector('.rev__score-big');
    if (scoreEl) {
      const raw = scoreEl.textContent.trim();
      const target = parseFloat(raw);
      if (!isNaN(target)) {
        const hasDecimal = raw.includes('.');
        const decimals = hasDecimal ? raw.split('.')[1].length : 0;

        scoreEl.dataset.final = raw;
        scoreEl.textContent = (0).toFixed(decimals);

        const countIO = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                animateScore(scoreEl, target, decimals, 1400);
                countIO.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.5 }
        );
        countIO.observe(scoreEl);
      }
    }

    // ---------- Star pop animation on card reveal ----------
    const cards = root.querySelectorAll('.rev__card');
    cards.forEach((card) => {
      const stars = card.querySelectorAll('.rev__card-stars .is-filled');
      if (!stars.length) return;

      // Pre-set starting state
      stars.forEach((star) => {
        star.style.display = 'inline-block';
        star.style.transform = 'scale(0) rotate(-180deg)';
        star.style.opacity = '0';
        star.style.transition = 'transform 0.55s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.4s ease';
      });

      const cardIO = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              stars.forEach((star, i) => {
                setTimeout(() => {
                  star.style.transform = 'scale(1) rotate(0)';
                  star.style.opacity = '1';
                }, 200 + i * 80);
              });
              cardIO.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.3 }
      );
      cardIO.observe(card);
    });

    // ---------- Carousel drag (mobile-friendly) ----------
    const carousel = root.querySelector('.rev__grid--carousel');
    if (carousel) {
      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;

      carousel.addEventListener('mousedown', (e) => {
        isDown = true;
        carousel.style.cursor = 'grabbing';
        startX = e.pageX - carousel.offsetLeft;
        scrollLeft = carousel.scrollLeft;
      });

      carousel.addEventListener('mouseleave', () => {
        isDown = false;
        carousel.style.cursor = '';
      });

      carousel.addEventListener('mouseup', () => {
        isDown = false;
        carousel.style.cursor = '';
      });

      carousel.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - carousel.offsetLeft;
        const walk = (x - startX) * 1.5;
        carousel.scrollLeft = scrollLeft - walk;
      });
    }
  }

  function animateScore(el, target, decimals, duration) {
    const start = performance.now();

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function tick(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOutCubic(progress);
      const value = target * eased;
      el.textContent = value.toFixed(decimals);

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = el.dataset.final;
      }
    }

    requestAnimationFrame(tick);
  }

  function initAll() {
    document.querySelectorAll('.rev[data-section-id]').forEach(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('.rev[data-section-id]');
    if (root) initReviews(root);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target.querySelector('.rev[data-section-id]');
    if (root) root.dataset.revInit = '';
  });
})();
